import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-tree-treenode {
    width: 100%;
  }

  .ant-tree-node-content-wrapper {
    flex: 1;
  }

  .ant-tree-node-selected {
    font-weight: 600;
  }
`
